import {setupHooks} from "./AutoFlip.js";
import { initConfig } from "./config.js";
import {registerSettings} from "./settings.js";
import { flip } from "./Flip.js";

CONFIG.Token.objectClass.prototype.flip = function (id) {
    flip(this, id);
};

export const MODULE_ID = "tokenflip";

Hooks.on("init", () => {
    initConfig();
    registerSettings();
});

Hooks.on("ready", () => {
    setupHooks();
});
